import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AppLayout } from "@/components/app-layout";
import { LoginPage } from "@/pages/login-page";
import { DashboardPage } from "@/pages/dashboard-page";
import { AccountsPage } from "@/pages/accounts-page";
import { GroupsPage } from "@/pages/groups-page";
import { CampaignsPage } from "@/pages/campaigns-page";
import { HistoryPage } from "@/pages/history-page";
import { RunDetailPage } from "@/pages/run-detail-page";
import { useSession } from "@/lib/session";

function FullPageLoader() {
    return (
        <div className="flex h-full items-center justify-center">
            <Loader2 className="size-6 animate-spin text-ink-muted" aria-label="Đang tải" />
        </div>
    );
}

export function App() {
    const { data: user, isPending } = useSession();

    if (isPending) return <FullPageLoader />;
    if (!user) return <LoginPage />;

    return (
        <BrowserRouter>
            <Routes>
                <Route element={<AppLayout />}>
                    <Route index element={<DashboardPage />} />
                    <Route path="accounts" element={<AccountsPage />} />
                    <Route path="groups" element={<GroupsPage />} />
                    <Route path="campaigns" element={<CampaignsPage />} />
                    <Route path="history" element={<HistoryPage />} />
                    <Route path="runs/:runId" element={<RunDetailPage />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}
